// @noflow
import Day from '../day';
import { getSelectedDayHeight } from '../utils';
import { isDependentOn } from '~/core/utils/custom-prop-types';
import PropTypes from 'prop-types';
import { range } from 'lodash/fp';
import * as React from 'react';

const DAYS_IN_WEEK = 7;

Week.propTypes = {
    componentId: PropTypes.string.isRequired,
    height: PropTypes.number.isRequired,
    isDragging: PropTypes.bool.isRequired,
    numEventsInSelectedDay: isDependentOn(
        ['selectedDay'],
        (_, selectedDay) => selectedDay !== null,
        PropTypes.number.isRequired
    ),
    selectedDay: PropTypes.number,
    sideMarginWidth: PropTypes.number.isRequired,
    temporaryStartTime: isDependentOn(['isDragging'], (_, isDragging) => isDragging, PropTypes.number.isRequired),
    top: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired
};

export default function Week({
    componentId,
    height,
    isDragging,
    numEventsInSelectedDay,
    selectedDay,
    sideMarginWidth,
    temporaryStartTime,
    top,
    width
}) {
    // if no day is selected the height will be equally spread into the 7 days of the week
    let dayHeight = Math.floor(height / DAYS_IN_WEEK);

    let selectedDayH;
    if (selectedDay !== null) {
        const { otherDayHeight, selectedDayHeight } = getSelectedDayHeight(height, numEventsInSelectedDay);
        dayHeight = otherDayHeight;
        selectedDayH = selectedDayHeight;
    }

    const days = range(0, 7).map(i => {
        const h = selectedDay === i ? selectedDayH : dayHeight;
        let t = dayHeight * i;
        if (selectedDay !== null && i > selectedDay) {
            t += selectedDayH - dayHeight;
        }
        return (
            <Day
                componentId={componentId}
                dayIndex={i}
                height={h}
                isDayDragging={selectedDay === i ? isDragging : false}
                key={`day-${i}`}
                sideMarginWidth={sideMarginWidth}
                temporaryStartTime={selectedDay === i ? temporaryStartTime : null}
                top={top + t}
                width={width}
            />
        );
    });

    return <g>{days}</g>;
}



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/week/component.js